import { useEffect, useState } from "react";
import { useNavigate, useLocation, useSearchParams } from "react-router-dom";
import Header from "../components/Header";
import Footer from "../components/Footer";
import Sidebar from "../components/SidebarUpdate";
import Pagination from "../components/Pagination_backend";
import { ClipLoader } from "react-spinners";
import apiInstance from "../apiConfig/apiinstance";
import DummyImage from "../assest/images/dummy_image.jpg";

const SearchResults = ({ setSearchInput }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [searchParams, setSearchParams] = useSearchParams();
  const searchQuery = searchParams.get("name");

  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const [totalResults, setTotalResults] = useState(0);
  // const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [paginatedCategoryImages, setPaginatedCategoryImages] = useState([]);

  const currentPage = parseInt(searchParams.get("currentPage")) || 1;

  const fetchSearchResults = async (page = 1) => {
    if (!searchQuery) return;

    setLoading(true);
    setError(null);

    try {
      const { data } = await apiInstance.get(
        // Replace with BaseUrl if needed
        `/api/style/v1/stylekuchbhi/elasticsearch/?q=${encodeURIComponent(
          searchQuery,
        )}&page=${page}`,
      );

      if (data.status === 200) {
        setPaginatedCategoryImages(data?.data?.results || []);
        setTotalPages(data?.data?.total_pages || 1);
        setTotalResults(data?.data?.count || 0);
      } else {
        setError("No products found matching your search.");
      }
    } catch (error) {
      setError(
        error?.response?.data?.message || "Failed to load search results",
      );
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (searchQuery) {
      fetchSearchResults(currentPage);
    }
  }, [searchQuery, currentPage]);

  const handlePageChange = (page) => {
    const params = new URLSearchParams(searchParams);
    if (page === 1) {
      params.delete("currentPage");
    } else {
      params.set("currentPage", page);
    }
    setSearchParams(params);
  };

  const handleProductClick = (styleId) => {
    const navigationState = {
      pathname: location.pathname,
      search: location.search,
      currentPage: currentPage,
      searchQuery: searchQuery,
    };
    sessionStorage.setItem(
      "lastNavigationState",
      JSON.stringify(navigationState),
    );

    navigate(`/search/product-detail/${styleId}`);
  };

  if (!searchQuery) {
    return (
      <div className="parent_Container">
        <Header />
        <div className="content_wrapper">
          <Sidebar logo="FP ONE" />
          <div
            style={{ overflowX: "hidden", width: "100%" }}
            className="md:ml-[18rem] mt-[5rem] md:mt-0"
          >
            <div
              className="error-message"
              style={{ padding: "20px", textAlign: "center" }}
            >
              <h2>No search query provided</h2>
              <button
                onClick={() => navigate("/")}
                className="back-home-btn"
                style={{
                  padding: "10px 20px",
                  marginTop: "10px",
                  backgroundColor: "#007bff",
                  color: "white",
                  border: "none",
                  borderRadius: "4px",
                  cursor: "pointer",
                }}
              >
                Go Back Home
              </button>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    );
  }

  return (
    <div className="parent_Container">
      <div className="content_wrapper">
        <Sidebar logo="FP ONE" />

        <div
          style={{ overflowX: "hidden", width: "100%" }}
          className="md:ml-[18rem] mt-[5rem] md:mt-0"
        >
          {/* Header */}
          <div
            className="search-results-header"
            style={{ padding: "20px", borderBottom: "1px solid #eee" }}
          >
            <h1 style={{ fontSize: "24px", marginBottom: "10px" }}>
              Search Results
            </h1>
            {searchQuery && (
              <p style={{ color: "#666", fontSize: "16px" }}>
                {loading
                  ? "Searching..."
                  : `${totalResults} results found for "${searchQuery}"`}
              </p>
            )}
          </div>

          <div className="separator"></div>

          {loading ? (
            <div className="loader-container">
              <ClipLoader color="#3498db" loading={loading} size={50} />
            </div>
          ) : error ? (
            <div className="no-products loader-container">{error}</div>
          ) : paginatedCategoryImages?.length === 0 ? (
            <div className="no-products loader-container">
              No products found matching your search.
            </div>
          ) : (
            <>
              {/* Products */}
              <div className="product_container">
                {paginatedCategoryImages.map((product) => (
                  <div className="cart" key={product.style_id}>
                    <div
                      className="image_container"
                      onClick={() => handleProductClick(product.style_id)}
                      style={{ cursor: "pointer" }}
                    >
                      <img
                        src={
                          product.cover_image_url ||
                          product.photos?.[0] ||
                          DummyImage
                        }
                        className="image"
                        loading="lazy"
                        alt={product.name || "Product"}
                        onError={(e) => {
                          e.target.onerror = null;
                          e.target.src = DummyImage;
                        }}
                      />
                    </div>
                  </div>
                ))}
              </div>

              {/* Pagination */}
              {totalPages > 1 && (
                <Pagination
                  totalPages={totalPages}
                  currentPage={currentPage}
                  onPageChange={handlePageChange}
                />
              )}
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default SearchResults;
